export const GET_COUNTDOWN_CLOCK_LIST = "GET_COUNTDOWN_CLOCK_LIST"
export const GET_COUNTDOWN_CLOCK_LIST_SUCCESS =
  "GET_COUNTDOWN_CLOCK_LIST_SUCCESS"
export const GET_COUNTDOWN_CLOCK_LIST_FAILED = "GET_COUNTDOWN_CLOCK_LIST_FAILED"
export const RESET_COUNTDOWN_CLOCK_LIST = "RESET_COUNTDOWN_CLOCK_LIST"

export const ADD_COUNTDOWN_CLOCK = "ADD_COUNTDOWN_CLOCK"
export const ADD_COUNTDOWN_CLOCK_SUCCESS = "ADD_COUNTDOWN_CLOCK_SUCCESS"
export const ADD_COUNTDOWN_CLOCK_FAILED = "ADD_COUNTDOWN_CLOCK_FAILED"

export const GET_COUNTDOWN_CLOCK = "GET_COUNTDOWN_CLOCK"
export const GET_COUNTDOWN_CLOCK_SUCCESS = "GET_COUNTDOWN_CLOCK_SUCCESS"
export const GET_COUNTDOWN_CLOCK_FALIED = "GET_COUNTDOWN_CLOCK_FAILED"
export const RESET_COUNTDOWN_CLOCK = "RESET_COUNTDOWN_CLOCK"

export const UPDATE_COUNTDOWN_CLOCK = "UPDATE_COUNTDOWN_CLOCK"
export const UPDATE_COUNTDOWN_CLOCK_SUCCESS = "UPDATE_COUNTDOWN_CLOCK_SUCCESS"
export const UPDATE_COUNTDOWN_CLOCK_FAILED = "UPDATE_COUNTDOWN_CLOCK_FAILED"

export const UPDATE_COUNTDOWN_CLOCK_ORDER = "UPDATE_COUNTDOWN_CLOCK_ORDER"
export const UPDATE_COUNTDOWN_CLOCK_ORDER_SUCCESS =
  "UPDATE_COUNTDOWN_CLOCK_ORDER_SUCCESS"
export const UPDATE_COUNTDOWN_CLOCK_ORDER_FAILED =
  "UPDATE_COUNTDOWN_CLOCK_ORDER_FAILED"

export const UPDATE_COUNTDOWN_CLOCK_STATUS = "UPDATE_COUNTDOWN_CLOCK_STATUS"
export const UPDATE_COUNTDOWN_CLOCK_STATUS_SUCCESS =
  "UPDATE_COUNTDOWN_CLOCK_STATUS_SUCCESS"
export const UPDATE_COUNTDOWN_CLOCK_STATUS_FAILED =
  "UPDATE_COUNTDOWN_CLOCK_STATUS_FAILED"

export const DELETE_COUNTDOWN_CLOCK = "DELETE_COUNTDOWN_CLOCK"
export const DELETE_COUNTDOWN_CLOCK_SUCCESS = "DELETE_COUNTDOWN_CLOCK_SUCCESS"
export const DELETE_COUNTDOWN_CLOCK_FAILED = "DELETE_COUNTDOWN_CLOCK_FAILED"
export const OPEN_DELETE_COUNTDOWN_CLOCK_MODAL =
  "OPEN_DELETE_COUNTDOWN_CLOCK_MODAL"
export const HIDE_DELETE_COUNTDOWN_CLOCK_MODAL =
  "HIDE_DELETE_COUNTDOWN_CLOCK_MODAL"
